document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('main[data-template="product"]')) return;

  const mainImages = document.querySelectorAll('.custom-gallery__main-image');
  const thumbs = document.querySelectorAll('.custom-gallery__thumb');

  // Клик по миниатюре → скролл к фото
  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', function () {
      if (mainImages[i]) {
        mainImages[i].scrollIntoView({ behavior: 'smooth', block: 'start' });
        thumbs.forEach((t, j) => t.classList.toggle('is-active', j === i));
      }
    });
  });

  // Подсвечиваем активную миниатюру при скролле
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const index = Array.from(mainImages).indexOf(entry.target);
        if (index !== -1) {
          thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
        }
      }
    });
  }, { threshold: 0.5 });

  mainImages.forEach(img => observer.observe(img));
});